<section class="w-full flex justify-center items-center">
	<div class="max-w-screen-xl w-full flex flex-col md:flex-row justify-center md:justify-between items-center mt-5 mb-5 px-4 md:px-0 ">
		<video #afVideo
			   (click)="playVideo(!autoPlayVideo)"
			   class="my-3 mx-6 rounded-md max-w-[94vw] md:max-w-[30%] cursor-pointer"
			   poster="https://anuprerna-bloomscorp.s3.ap-south-1.amazonaws.com/artisan-flow/artisan-flow-video-thumbnail.png"
			   src="https://anuprerna-bloomscorp.s3.ap-south-1.amazonaws.com/artisan-flow/artisan-flow-demo-mobile.mp4"
			   playsinline
			   preload="metadata"
			   [muted]="true"
			   [autoplay]="autoPlayVideo"></video>
		<div class="md:flex-[60%] max-w-screen-md text-center md:text-start">
			<p class="max-w-screen-md text-sm mb-0.5 mt-8">
				<span class="text-[#7d5b20] font-bold">EMBRACE</span> transparency, <span class="text-[#7d5b20] font-bold">EMPOWER</span> artisans, and <span class="text-[#7d5b20] font-bold">ENABLE</span> a sustainable future.
			</p>
			<h2 class="text-3xl sm:text-5xl text-[#7D5B20] font-semibold mb-2 ">
				<span class="text-black">Introducing</span> <a routerLink="/artisanflow" target="_blank"> ArtisanFlow</a>
			</h2>
			<fb-fabric-flow-stats></fb-fabric-flow-stats>
			<p class="text-sm md:text-base text-gray-700 pt-3">
				Managing an <span class="font-bold">artisanal supply chain</span> has never been easier. Our platform
				<span class="font-bold">simplifies supply chain complexity</span> by providing
				<span class="font-bold">real-time tracking & analytics</span> at every stage of production.
<!--				From <span class="font-bold">sourcing raw materials</span> to final delivery, users gain complete-->
<!--				<span class="font-bold">transparency & visibility</span> into their-->
<!--				<span class="font-bold">manufacturing workflow</span>, ensuring they stay informed and in control.-->
			</p>
			<a [routerLink]="'/artisanflow'"
			   target="_blank"
			   class="w-full sm:w-max bg-[#fffcf7] hover:bg-white hover:shadow-md rounded md:rounded-lg border-2 border-[#8E7862] text-[#7D5B20] py-1 px-3 hover:border-[#6c5b48]
						transition flex items-center justify-center gap-2 text-sm sm:text-xl mt-4">
				<i class="fb_animate"><b ></b><span></span></i>
				Get Started with ArtisanFlow
			</a>
		</div>
	</div>
</section>
